// removed by extract-text-webpack-plugin
module.exports = {"modalHeader":"_2NEHPRt8AX1qQzybMYJUix","linkButton":"z9CTxOyx5Es74axKMosYa"};


//////////////////
// WEBPACK FOOTER
// ./src/components/registrationFormWrapper/registrationFormWrapperComponent.scss
// module id = 683
// module chunks = 22